import { render, staticRenderFns } from "./RecommendedBadge.vue?vue&type=template&id=edb4b99a&scoped=true&"
import script from "./RecommendedBadge.vue?vue&type=script&lang=js&"
export * from "./RecommendedBadge.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedBadge.vue?vue&type=style&index=0&id=edb4b99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb4b99a",
  null
  
)

export default component.exports